module.exports = __webpack_public_path__ + "img/13.69e52e06.png";